import { State } from "../types";

export type UndoAction = Readonly<{
  type: "UNDO";
}>;

export const undo = (state: State, _action: UndoAction): State => {
  if (state.cellHistoryIndex <= 0) {
    return state;
  }
  return {
    ...state,
    cellHistoryIndex: state.cellHistoryIndex - 1,
    cells: state.cellHistory[state.cellHistoryIndex - 1],
  };
};
